<template>
	<div class="uupay-container">

    <UUPayBannerProduct banner-img="console_banner" :banner-img-right="true">
      <template v-slot:title>
        <div><img src="@/assets/uupay/images/logo_product.png" class="img-fluid"></div> 
        <div class="banner-title-uu">控制台</div>
      </template>
      <template v-slot:subtitle>
        用數據捕捉每一個細節
      </template>
      <template v-slot:info>
        線下門市專用UUPAY收款機，無縫連結UUPAY APP，隨時隨地管理你的機器
      </template>
    </UUPayBannerProduct>

    <product-feature :list="productFeatures" />


    <func-feature :title="funcTitle" :list="funcFeatures"/>

    <safe-account :list="safeList" />

    <UUPayBannerContact :info="['我準備好了！你呢？']" />
  </div>
</template>
<script>
import UUPayBannerContact from "@/components/uupayBannerContact";
import ProductFeature from "@/components/ProductFeature";
import UUPayBannerProduct from "@/components/uupayBannerProduct";
import FuncFeature from "@/components/FuncFeature";
import SafeAccount from "@/components/SafeAccount";

export default {
  name: 'UUPayConsole',
  components: {
    UUPayBannerContact,
    ProductFeature,
    UUPayBannerProduct,
    FuncFeature,
    SafeAccount
  },
  data() {
    return {
      productFeatures: [
        {id: 0, imgSrc: 'console_feather', desc: '數據分析'},
        {id: 1, imgSrc: 'console_check_circle', desc: '審批管理'},
        {id: 2, imgSrc: 'console_award', desc: '交易監管'},
        {id: 3, imgSrc: 'console_users', desc: '帳戶管理'},
      ],
      funcTitle: {
        highLight: '最完整',
        desc: '控制台',
      },
      funcFeatures: [
        {
          id: 0, imgSrc: 'console_finance_report', title: '財務報表', imgStyle: {}, imgClass: 'align-items-center',
          info: [
            {id: 0, desc: '詳細分析報告'},
            {id: 1, desc: '多角度數據展示'},
            {id: 2, desc: '幫助商戶做出最好生意決策'},
          ]
        },
        {
          id: 1, imgSrc: 'console_trade_inspect', title: '過往交易監管', imgStyle: {}, imgClass: 'align-items-center',
          info: [
            {id: 0, desc: '系統保留所有交易紀錄'},
            {id: 1, desc: '隨時查看任何交易紀錄'},
            {id: 2, desc: '管理單一或一組交易，例如退款和取消订单'},
          ]
        },
        {
          id: 3, imgSrc: 'console_order_list', title: '訂單數據管理', imgStyle: {}, imgClass: 'align-items-center',
          info: [
            {id: 0, desc: '簡化所有內部和外部會計流程'},
            {id: 1, desc: '列表式查看和審查結算記錄'},
            {id: 2, desc: '追蹤結算的操作處理記錄'},
          ]
        },
      ],
      safeList: [
        {id: 0, imgSrc: 'app_pci_level', title: 'PCI Level 1', style: {height: '60px', 'margin': '1rem 0 0.3rem 0'},
         desc: '使用端對端加密技術把交易的所有數據加密傳輸，確保信用卡資料保密和交易安全。'},
        {id: 0, imgSrc: 'app_visa', title: 'Visa PayWave', style: {},
         desc: 'Visa PayWave 支援使用 Visa 卡或裝置透過射頻或 NFC 技術進行非接觸式支付，減少信用卡被盗機會。'},
        {id: 0, imgSrc: 'app_master', title: 'Mastercard Paypass', style: {},
         desc: 'Mastercard Paypass 透過 NFC 技術，只需輕觸銀行卡、手機或其他支付設備即可實現快速、簡單的支付。'},
        {id: 0, imgSrc: 'app_unionpay', title: 'UnionPay', style: {},
         desc: '獲銀聯認證之支付平台，可以受理銀聯IC卡進行交易。'},
        {id: 0, imgSrc: 'app_swift', title: 'SVF', style: {},
         desc: '獲香港儲值支付工具牌照，合法營運線上支付、銷售點流動支付、P2P轉帳、實體卡四個方面'},
        {id: 0, imgSrc: 'app_mso', title: 'MSO', style: {},
         desc: '獲得權威批准-代表在港貨幣及外匯市場上獲得了“通行證”，每一筆交易都是接受香港政府監督，100%合規保障。'},
      ]
    }
  },

}
</script>
<style scoped>


.modules-section {
  margin: 100px 0;
}

.modules-section-container {
  max-width: 1440;
}
.modules-section .content {
  background-color: #f8f8f8;
  border-radius: 6px;
}
.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}
.modules-section .title {
  font-size: 30px;
  line-height: 100%;
  color: #21042e;
  margin-bottom: 1rem;
  font-weight: 600;
}
.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}

.why-us-section {
  background-color: #f8f8f8;
  padding: 121px 0;
}
.why-us-section .container {
  max-width: 1440px;
}
.why-us-section .info {
  width: 500px;
  background-color: #fff;
  border-radius: 6px;
  padding: 3rem;
}
.why-us-section .info .question {
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  color: #9a307a;
  margin-bottom: 2.3rem;
}
.why-us-section .info .answer-title {
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: #21042e;
  margin-bottom: 1rem;
}
.why-us-section .info .answer-detail {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #4d4d4d;
}
.why-us-section .info .answer-icon {
  margin: 0.3rem 0.6rem 0 0;

}
</style>


// WEBPACK FOOTER //
// src/views/uupayConsole.vue